import { PropsWithChildren, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useCaMap } from "../../state";

type CustomControlProps = {
  position: "top-left" | "top-right" | "bottom-left" | "bottom-right";
  className?: string;
  style?: string;
  first?: boolean;
};

// https://github.com/visgl/react-map-gl/discussions/1728#discussioncomment-13036282
//
// Zoekt de hoek in de kaart van de dichtstbijzijnde CaMapProvider, niet in het
// hele document: de verborgen globale kaart blijft gemount en staat in de DOM
// vóór de werkruimtekaart, dus een globale querySelector zette controls van de
// werkruimte op die onzichtbare kaart.
export const CustomControl = ({
  position,
  className = "maplibregl-ctrl maplibregl-ctrl-group",
  first,
  style,
  children,
}: PropsWithChildren<CustomControlProps>) => {
  const map = useCaMap();
  const [groupContainer, setGroupContainer] = useState<HTMLDivElement>(null);
  useEffect(() => {
    const parentElement = map?.getContainer().querySelector(".maplibregl-ctrl-" + position);
    if (!parentElement) return;

    const groupDiv = document.createElement("div");
    groupDiv.className = className;
    groupDiv.style = style;
    setGroupContainer(groupDiv);
    parentElement[first ? "prepend" : "append"](groupDiv);

    return () => {
      parentElement.removeChild(groupDiv);
    };
  }, [map, position, className, first, style]);

  if (!groupContainer) return null;
  return createPortal(<>{children}</>, groupContainer);
};
